// Last-resort fallback so the header never renders empty if /api/navigation
// fails. The live structure always comes from the backend (admin-editable).
export const NAV_FALLBACK = [
  { id: "home", label: "Home", url: "/", type: "link" },
  {
    id: "about", label: "About Us", type: "group", children: [
      { id: "about-us", label: "About Us", url: "/about", type: "link" },
      { id: "team", label: "Meet the Team", url: "/team", type: "link" },
      { id: "careers", label: "Careers", url: "/careers", type: "link" },
    ],
  },
  {
    id: "services", label: "Services", type: "group", mega: "services", children: [
      { id: "legal-cashiering", label: "Legal Cashiering", url: "/legal-cashiering", type: "link", icon: "Scale", accent: true, desc: "Specialist division for licensed conveyancers" },
      { id: "switching", label: "Switching to CASS", url: "/switching-accountants", type: "link", icon: "ArrowRight", accent: true, desc: "Changing accountant is easier than you think" },
    ],
  },
  {
    id: "more", label: "More Than Numbers", type: "group", children: [
      { id: "assessment-tools", label: "Business Assessment Tools", url: "/more-than-numbers/business-assessment-tools", type: "link", badge: "Free" },
      { id: "mtd", label: "MTD for Income Tax Checker", url: "/making-tax-digital-income-tax", type: "link" },
      { id: "tax-dates", label: "Key Tax Dates", url: "/key-tax-dates", type: "link" },
      { id: "insights", label: "Insights", url: "/insights", type: "link" },
      { id: "free-resources", label: "Free Resources", url: "/insights#free-resources", type: "link", badge: "Free" },
      { id: "blog", label: "Blog Posts", url: "/blog", type: "link" },
      { id: "podcast", label: "Podcast", url: "/podcast", type: "link" },
      { id: "meeting-room", label: "Meeting Room Hire", url: "/meeting-room-hire", type: "link" },
    ],
  },
  { id: "ask-cassie", label: "Ask Cassie", url: "/ask-cassie", type: "link" },
  { id: "testimonials", label: "Testimonials", url: "/testimonials", type: "link" },
  { id: "pricing", label: "Pricing", url: "/pricing", type: "link", condition: "package_live" },
  { id: "contact", label: "Contact", url: "/contact", type: "link" },
];
